import { ApiClient } from './ApiClient';
import { AuthService } from '../AuthService';

const enableLogging = String(process.env.VUE_APP_API_LOGGING || '').toLowerCase() === 'true';

export const apiClient = new ApiClient({
  getToken: () => localStorage.getItem('accessToken'),
  onUnauthorizedRefresh: async () => {
    // Automatic token refresh on 401 responses
    // Returns new token or null if refresh fails (forces re-login)
    return await AuthService.refreshToken();
  },
  enableLogging,
  baseURL: process.env.VUE_APP_API_PREFIX,
});


